<!-- Activar modal de error-->
<button id="btnModalError" type="button" class="btn btn-primary visually-hidden" data-bs-toggle="modal" data-bs-target="#modalError"> error </button>

<!-- Modal de error -->
<div class="modal fade" id="modalError" tabindex="-1" aria-labelledby="modalErrorLabel" aria-hidden="true">
    <div class="modal-dialog alert alert-danger ">
        <div class="modal-content">
            <div class="text-center my-3">
                <h5 class="modal-title fw-bold "> {{ tituloModal }} </h5>
            </div>

            <hr style="height: 1px; opacity: 0.20; width: 100%; margin: auto">

            <div class="modal-body text-center my-2">
                <p class="fst-italic"> {{ mensajeModal }} </p>
                <small class="my-4"> Para cerrar el aviso haga clic fuera de este </small>
            </div>
        </div>
    </div>
</div>

<!-- Activar modal procesado -->
<button id="btnModalProcesado" type="button" class="btn btn-primary visually-hidden" data-bs-toggle="modal" data-bs-target="#modalProcesado"> faltan campos </button>

<!-- Modal procesado -->
<div class="modal fade" id="modalProcesado" tabindex="-1" aria-labelledby="modalProcesadoLabel" aria-hidden="true">
    <div class="modal-dialog alert alert-success">
        <div class="modal-content">

            <div class="text-center my-3">
                <h5 class="modal-title fw-bold "> {{ tituloModal }} </h5>
            </div>

            <hr style="height: 1px; opacity: 0.20; width: 100%; margin: auto">

            <div class="modal-body text-center my-2">
                <p class="fst-italic"> {{ mensajeModal }} </p>
                <small class="my-4"> Para cerrar el aviso haga clic fuera de este </small>
            </div>

        </div>
    </div>
</div>

<!-- Activar modal procesando -->
<button id="btnModalProcesando" type="button" class="btn btn-success visually-hidden" data-bs-toggle="modal" data-bs-target="#modalProcesando"> procesando </button>

<!-- Modal procesando-->
<div class="modal fade" id="modalProcesando" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalProcesandoLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content" style="width: 100%; height: 50%;">
            <div class="modal-body">
                <div class="container">

                    <div class="text-center mt-4">

                        <div class="spinner-grow alert-primary align-middle mx-1" style="width: 0.5rem; height: 0.5rem;" role="status">
                            <span class="visually-hidden"> cargando... </span>
                        </div>

                        <div class="spinner-grow alert-primary align-middle mx-1" style="width: 1rem; height: 1rem;" role="status">
                            <span class="visually-hidden"> cargando... </span>
                        </div>

                        <div class="spinner-grow alert-primary align-middle mx-1" style="width: 1.5rem; height: 1.5rem;" role="status">
                            <span class="visually-hidden"> cargando... </span>
                        </div>

                        <div class="spinner-grow alert-primary align-middle mx-1" style="width: 2rem; height: 2rem;" role="status">
                            <span class="visually-hidden"> cargando... </span>
                        </div>

                        <div class="spinner-grow alert-primary align-middle mx-1" style="width: 2.5rem; height: 2.5rem;" role="status">
                            <span class="visually-hidden"> cargando... </span>
                        </div>
                    </div>

                    <p class="text-center my-4"><strong> Procesando solicitud ... </strong></p>

                </div>

                <button id="btnCerrarModalProcesando" type="button" class="btn btn-primary visually-hidden" data-bs-dismiss="modal"> Cerrar </button>

            </div>
        </div>
    </div>
</div>